/**
 * SkipLink - Accessible skip navigation component
 * 
 * Provides a hidden link that becomes visible on focus, allowing keyboard
 * users to bypass navigation and jump directly to main content.
 * WCAG 2.2 Success Criterion 2.4.1 (Bypass Blocks)
 */
export default function SkipLink() {
    return (
        <a
            href="#main-content"
            className="sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4 focus:z-[100] focus:bg-primary-500 focus:text-white focus:px-4 focus:py-2 focus:rounded-lg focus:font-semibold focus:outline-none focus:ring-2 focus:ring-white"
        >
            Skip to main content
        </a>
    );
}
